export var eventSection = function (isQuickQuotePage) {
    return "qq ".concat(isQuickQuotePage ? 'page' : 'widget');
};
